/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ extension: NonNullable<unknown> }} Chat_Blob_Save_Dialog_Extension_LockedInputs */



/**
* | output |
* | --- |
* | "The {extension} extension is fixed by the file's type and cannot be changed." |
*
* @param {Chat_Blob_Save_Dialog_Extension_LockedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_blob_save_dialog_extension_locked = /** @type {((inputs: Chat_Blob_Save_Dialog_Extension_LockedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Blob_Save_Dialog_Extension_LockedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Endung ${i?.extension} ergibt sich aus dem Dateityp und kann nicht geändert werden.`)
	return /** @type {LocalizedString} */ (`The ${i?.extension} extension is fixed by the file's type and cannot be changed.`)
});